var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.517 103.813L249.777 208.073L291.481 249.777L395.74 354.036L354.036 395.74L249.777 291.481L208.073 249.777L103.813 145.517L145.517 103.813Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.813 354.037L208.073 249.777L249.777 208.073L354.036 103.813L395.74 145.517L291.481 249.777L249.777 291.481L145.517 395.74L103.813 354.037Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 108.5,
    r: 70.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5 81.75V95.125L126.333 77.2917L108.5 59.4584V72.8334C88.7941 72.8334 72.8333 88.7942 72.8333 108.5C72.8333 115.5 74.8841 122.009 78.3616 127.493L84.8708 120.983C82.8645 117.283 81.7499 113.003 81.7499 108.5C81.7499 93.743 93.7428 81.75 108.5 81.75ZM138.638 89.5075L132.129 96.0167C134.091 99.7617 135.25 103.997 135.25 108.5C135.25 123.257 123.257 135.25 108.5 135.25V121.875L90.6666 139.708L108.5 157.542V144.167C128.206 144.167 144.167 128.206 144.167 108.5C144.167 101.5 142.116 94.9913 138.638 89.5075V89.5075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.5,
    cy: 108.5,
    r: 70.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 391.5,
    r: 70.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.5,
    cy: 391.5,
    r: 70.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.5 81.75V95.125L373.667 77.2917L391.5 59.4584V72.8334C411.206 72.8334 427.167 88.7942 427.167 108.5C427.167 115.5 425.116 122.009 421.638 127.493L415.129 120.983C417.135 117.283 418.25 113.003 418.25 108.5C418.25 93.743 406.257 81.75 391.5 81.75ZM361.362 89.5075L367.871 96.0167C365.909 99.7617 364.75 103.997 364.75 108.5C364.75 123.257 376.743 135.25 391.5 135.25V121.875L409.333 139.708L391.5 157.542V144.167C371.794 144.167 355.833 128.206 355.833 108.5C355.833 101.5 357.884 94.9913 361.362 89.5075V89.5075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5 364.75V378.125L90.6667 360.292L108.5 342.458V355.833C128.206 355.833 144.167 371.794 144.167 391.5C144.167 398.5 142.116 405.009 138.638 410.493L132.129 403.983C134.135 400.283 135.25 396.003 135.25 391.5C135.25 376.743 123.257 364.75 108.5 364.75ZM78.3617 372.508L84.8709 379.017C82.9092 382.762 81.7501 386.997 81.7501 391.5C81.7501 406.257 93.743 418.25 108.5 418.25V404.875L126.333 422.708L108.5 440.542V427.167C88.7942 427.167 72.8334 411.206 72.8334 391.5C72.8334 384.5 74.8842 377.991 78.3617 372.508V372.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.5 364.75V378.125L409.333 360.292L391.5 342.458V355.833C371.794 355.833 355.833 371.794 355.833 391.5C355.833 398.5 357.884 405.009 361.362 410.493L367.871 403.983C365.865 400.283 364.75 396.003 364.75 391.5C364.75 376.743 376.743 364.75 391.5 364.75ZM421.638 372.508L415.129 379.017C417.091 382.762 418.25 386.997 418.25 391.5C418.25 406.257 406.257 418.25 391.5 418.25V404.875L373.667 422.708L391.5 440.542V427.167C411.206 427.167 427.167 411.206 427.167 391.5C427.167 384.5 425.116 377.991 421.638 372.508V372.508Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrone);
export default __webpack_public_path__ + "static/media/Drone.ccef68c8d647a38294ee1886f90ba965.svg";
export { ForwardRef as ReactComponent };